

import { render } from "solid-js/web";
import "./styles/tailwind.css";
import App from "./App";

render(() => <App />, document.getElementById("root")!);
